module.exports = __webpack_public_path__ + "static/image14@2x-e10095cc33157d62f8326053b330a280.png";